// src/pages/PostDetail/index.jsx
import React, { useState, useEffect } from 'react';
import { Tag, Space, Button, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './index.css';

const PostDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getAllPosts } = useAuth();
  const [post, setPost] = useState(null);

  useEffect(() => {
    // 获取所有文章并查找指定ID的文章
    const allPosts = getAllPosts();
    const postId = parseInt(id, 10); // 明确指定进制
    const foundPost = allPosts.find(p => p.id === postId);
    
    if (foundPost) {
      setPost(foundPost);
      // 设置页面标题为文章标题
      document.title = `${foundPost.title} - 我的博客`;
    } else {
      message.error('文章不存在');
      // 延迟跳转，让用户看到错误提示
      setTimeout(() => {
        navigate('/');
      }, 1500);
    }
  }, [id, navigate, getAllPosts]);

  // 当组件卸载时恢复默认标题
  useEffect(() => {
    return () => {
      document.title = '我的博客 - 分享技术、生活和思考';
    };
  }, []);

  if (!post) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto',
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#0c4a6e'
      }}>
        <p>正在加载文章...</p>
      </div>
    );
  }

  return (
    <div className="post-detail-page">
      <Button 
        type="link" 
        className="back-button"
        onClick={() => navigate(-1)}
      >
        ← 返回
      </Button>
      
      <div className="post-header">
        <h1 className="post-title">{post.title}</h1>
        
        <div className="post-meta">
          <div style={{ color: '#67e8f9', fontSize: '1rem' }}>
            {post.date}{post.author && <span style={{ marginLeft: '1rem' }}> • 作者: {post.author}</span>}
          </div>
          <Space wrap className="post-tags">
            {post.tags && post.tags.map((tag, index) => (
              <Tag key={index} className="post-tag">{tag}</Tag>
            ))}
          </Space>
        </div>
      </div>
      
      <div className="post-content">
        {post.content && post.content.split('\n\n').map((paragraph, index) => {
          const trimmedParagraph = paragraph.trim();
          return trimmedParagraph ? (
            <p key={index}>{trimmedParagraph}</p>
          ) : null;
        }).filter(Boolean)}
      </div>
    </div>
  );
};

export default PostDetail;